
const requireComponent = require.context(
  './iview', // 查找的目录
  false, // 是否查找子目录
  /Iview[\w]+\.vue$/ // 查找文件名包含Iview的文件
)

const cs1=require.context('./common',false,/\.vue$/)

export default {
  install(Vue) {
    cs1.keys().map(item => Vue.component(cs1(item).default.name, cs1(item).default))
    // ---------------------------
    // For each matching file name...
    requireComponent.keys().forEach((fileName) => {
      // Get the component config
      const componentConfig = requireComponent(fileName)
      // Get the PascalCase version of the component name
      const componentName = fileName
        // Remove the "./" from the beginning
        .replace(/^\.\//, '')
        // Remove the file extension from the end
        .replace(/\.\w+$/, '')

      // Globally register the component
      Vue.component(componentName, componentConfig.default || componentConfig)
    })
  }
}
